import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    signOut: "تسجيل الخروج"
  },
  profile: {
    title: "الملف الشخصي",
    dangerZone: "منطقة الخطر",
    deleteAccount: "حذف الحساب",
    confirmDelete: "تأكيد الحذف",
    deleteWarning: "هل أنت متأكد من رغبتك في حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء.",
    confirmDeleteButton: "حذف الحساب",
    accountDeleted: "تم حذف الحساب",
    accountDeletedMessage: "تم حذف حسابك بنجاح."
  },
  cancel: "إلغاء",
  delete: "حذف",
  deleteConfirmation: "تأكيد الحذف",
  deleteConfirmationMessage: "هل أنت متأكد أنك تريد حذف",
  confirm: "تأكيد",
  errors: {
    error: "خطأ",
    notFound: "الصفحة غير موجودة",
    deleteAccountError: "حدث خطأ أثناء حذف حسابك. يرجى المحاولة مرة أخرى.",
    loadStoryError: "فشل في تحميل القصة. يرجى المحاولة مرة أخرى.",
    loadCharactersError: "فشل في تحميل الشخصيات. يرجى المحاولة مرة أخرى.",
    summaryError: "خطأ في إنشاء الملخص. يرجى المحاولة مرة أخرى."
  }
};
